module.exports = __webpack_public_path__ + "static/media/sweetalert_info.45a9aec2.svg";